import { HexagonCard } from "./HexagonCard";
export default HexagonCard;
